var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyLinkGreen = function SvgCopyLinkGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    x: 0.5,
    fill: "#3A786C",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.954 13.166a.504.504 0 0 0 0 .727 2.1 2.1 0 0 1 0 3.022l-4.485 4.378a2.23 2.23 0 0 1-3.097 0l-.675-.659a2.1 2.1 0 0 1 0-3.022l4.485-4.377a.504.504 0 0 0 0-.727.534.534 0 0 0-.745 0l-4.485 4.377a3.11 3.11 0 0 0 0 4.476l.675.659a3.28 3.28 0 0 0 2.293.925 3.28 3.28 0 0 0 2.294-.925l4.485-4.377a3.116 3.116 0 0 0 0-4.477.534.534 0 0 0-.745 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.052 7.587-.675-.659a3.31 3.31 0 0 0-4.589 0l-4.487 4.377a3.115 3.115 0 0 0 0 4.476.535.535 0 0 0 .745 0 .503.503 0 0 0 0-.727 2.1 2.1 0 0 1 0-3.022l4.487-4.377a2.23 2.23 0 0 1 3.099 0l.675.659a2.1 2.1 0 0 1 0 3.022l-4.488 4.377a.503.503 0 0 0 0 .727.54.54 0 0 0 .371.152.52.52 0 0 0 .37-.152l4.488-4.377a3.11 3.11 0 0 0 .004-4.476"
  })))));
};
export default SvgCopyLinkGreen;